import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const ArrowVertical = (props) => (
  <Icon viewBox="0 0 7 9" {...props}>
    <g>
      <title>7762852E-35A4-40FC-BA75-3D07C1D10D08</title>
      <path d="M3.5 0L0 3.375.5 4 3 1.499V9l.999-2V1.499L6.5 4l.5-.625z" fill="currentColor" fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default ArrowVertical;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/ArrowVertical.js